<template>
  <div id="chat-group">
    <stream v-if="chatWindowStatus == 3 && threadState != 'closed'"  id="videocall" ></stream>
    <div class="chat-window-container">
      <chat-window :business_group="business_group" v-if="this.isChatOpened"></chat-window>
      <chat-button :business_group="business_group" v-else></chat-button>
    </div>
  </div>
</template>

<script>
import ChatButton from "@/components/ChatButton.vue";
import ChatWindow from "@/components/ChatWindow.vue";
import store from "@/store";
import { mapGetters, mapState } from "vuex";
import Stream from "@/components/VideoCall/Stream.vue";

const ikeaStyle = () => import('../assets/scss/ikea.scss');
const ventajonStyle = () => import('../assets/scss/ventajon.scss');


export default {
  store,
  name: 'Window',
  components: {
    Stream,
    ChatWindow,
    ChatButton
  },
  mounted: function () {
    console.log('Videochat Front - App mounted');
    //TODO REFACTOR
    if (this.business_group === 2) {
      ikeaStyle();
    }
    if (this.business_group === 1) {
      ventajonStyle();
    }

    window.addEventListener('beforeunload', this.removeVideoCallFromLocalStorage);

    // Exponer función global para abrir el chat desde la app principal
    window.openVideoChat = () => {
      this.$store.commit('setChatOpen', true);
    };

    // También escuchar eventos custom (alternativa)
    window.addEventListener('openVideoChat', () => {
      this.$store.commit('setChatOpen', true);
    });
    // Remove store.http.on usage
    // if (store.http) {
    //   store.http.on('newMessage', this.handleNewMessage);
    // }
  },
  created: function () {
    const linkNode = document.createElement('link');
    linkNode.type = 'text/css';
    linkNode.rel = 'stylesheet';
    linkNode.href = 'https://static.islas.ikea.es/assets/modules/pws/test/fonts.css?v=5';
    //linkNode.href = 'https://pasapaginas1.s3-website-eu-west-1.amazonaws.com/modules/pws/fonts/fonts.css?v=4';
    document.head.appendChild(linkNode);
  },
  methods: {
    ...mapGetters(['threadState']),
    removeVideoCallFromLocalStorage() {
      if(localStorage.getItem('video_call')){
        window.location.href = localStorage.getItem('video_call');
        localStorage.removeItem('video_call');
      }
    },
  },
  computed: {
    ...mapState(["business_group", 'call', 'chatWindowStatus', 'isChatOpened'])
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.removeVideoCallFromLocalStorage);
    window.removeEventListener('openVideoChat', this.handleOpenChat);
    delete window.openVideoChat;
    // Remove store.http.off usage
    // if (store.http) {
    //   store.http.off('newMessage', this.handleNewMessage);
    // }
  },
}
</script>


<style scoped>
.vc-overlay *,
.vc-overlay :after,
.vc-overlay :before {
  box-sizing: border-box;
  text-decoration: none;
  -webkit-touch-callout: none;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0
}

.vc-title {
  color: var(--title-color);
  font-weight: var(--font-weight-black);
  font-size: var(--font-size-m);
  margin-bottom: 5px
}

.vc-text,
.vc-title {
  padding: 0 1rem;
  width: 100%;
  text-align: center;
  line-height: normal;
  box-sizing: border-box;
}

.vc-text {
  color: var(--message-color);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-s)
}

.vc-container {
  background-color: var(--base-background-color);
  border-radius: 1rem;
  width: 286px;
  height: auto;
  display: grid;
  grid-template-rows:1fr -webkit-max-content;
  grid-template-rows:1fr max-content;
  box-shadow: var(--container-box-shadow)
}

.vc-text-grid {
  padding: 1rem
}

.vc-btn-grid {
  width: 100%;
  display: grid;
  grid-template-columns:1fr 1fr;
  border-radius: 0 0 1rem 1rem;
  overflow: hidden
}

.vc-btn-grid.isMono {
  grid-template-columns:1fr
}

.vc-btn {
  border-radius: 0 0 1rem 0;
  color: var(--button-color);
  background-color: var(--button-background-color);
  border: 0;
  font-size: 1rem;
  border-top: 1px solid var(--button-border-color);
  cursor: pointer;
  font-weight: var(--font-weight-bold);
  outline: none;
  min-height: 50px
}

.vc-btn:hover {
  background-color: var(--button-background-color-hover)
}

.vc-btn:disabled {
  background-color: var(--button-background-color-disabled)
}

.vc-btn:active {
  box-shadow: var(--button-box-shadow-active)
}

.vc-btn.left {
  border-radius: 0;
  border-right: 1px solid var(--button-border-color)
}

.vc-input[type=password] {
  width: 100%;
  outline: none;
  border-radius: 8px;
  height: 35px;
  border: 0;
  margin: 5px 0;
  background-color: var(--input-background-color);
  padding: 0 .5rem;
  font-size: var(--font-size-m);
  transition: .21s ease
}

.vc-input[type=password]:focus, .vc-input[type=password]:hover {
  background-color: var(--input-background-color-hover)
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .21s
}

.fade-enter, .fade-leave-to {
  opacity: 0
}

.zoom-enter-active, .zoom-leave-active {
  animation-duration: .21s;
  animation-fill-mode: both;
  animation-name: zoom
}

.zoom-leave-active {
  animation-direction: reverse
}

@keyframes zoom {
  0% {
    opacity: 0;
    transform: scale3d(1.1, 1.1, 1.1)
  }
  to {
    opacity: 1;
    transform: scaleX(1)
  }
}
</style>

<style lang="scss">
@import "../assets/fonts/fonts_local.css";
@import "../assets/css/pws-icons.css";
@import '../assets/scss/pws.scss';
</style>
